import { ChangeDetectionStrategy, Component, input, numberAttribute } from '@angular/core';

@Component({
  selector: 'ca-avatar',
  standalone: true,
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.width.px]': `size()`,
    '[style.height.px]': `size()`,
  },
})
export class AvatarComponent {
  placeholder = input.required<string>();
  image = input.required<string>();
  size = input(40, { transform: numberAttribute });
}
